import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, "Số lượng", -1)
const _hoisted_2 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex break-word align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Thành tiền")
], -1)
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0 break-word" }, "Đơn vị tính", -1)
const _hoisted_8 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_9 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isDialogDisplay,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDialogDisplay) = $event)),
    width: "70%",
    title: "Vật tư ĐMCĐ",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        style: {"width":"100%"},
        size: "small",
        "max-height": "800",
        "empty-text": "Chưa có vật tư trong định mức",
        "cell-style": {padding: '0', height: '15px'},
        "cell-class-name": _ctx.isTextDangerColumn,
        border: true,
        data: _ctx.dataItems
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "ID",
            width: "50"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_word_break_column, {
            "header-title": "Tên",
            property: "ten_vat_tu"
          }),
          _createVNode(_component_el_table_column, { label: "Mã" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "C/ty duyệt" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                value: _ctx.dataItems[scope.$index].cong_ty_duyet,
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Trạng thái",
            width: "90"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(scope.row.pivot.so_luong), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Đơn giá" }, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.don_gia)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(
                  parseFloat(scope.row.don_gia) * scope.row.pivot.so_luong,
                  false
                )), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "ĐVT" }, {
            header: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(scope.row.don_vi_tinh), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            width: "50",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ButtonCustom, {
                  "color-type": _ctx.ButtonTypeColors.INFO,
                  "button-type": _ctx.ButtonsType.INFO,
                  onClick: ($event: any) => (_ctx.push(`/quan-ly/vat-tu/chi-tiet/${scope.row.id}`))
                }, null, 8, ["color-type", "button-type", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["cell-class-name", "data"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}